export const getClientObj = (clientList, clientValue) =>
  clientList?.find((c) => c.clientValue === clientValue);

export const getOrchardObj = (clientObj, orchardValue) =>
  clientObj?.orchardValue?.find((o) => o.orchardValue === orchardValue);

export const getCcObj = (orchardObj, ccValue) =>
  orchardObj?.ccValue?.find((cc) => cc.ccValue === ccValue);

export const getQuarterObj = (ccObj, quarterValue) =>
  ccObj?.quarterValue?.find((q) => q.quarterValue === quarterValue);

export const clearSelects = (setValue, fields) => {
  fields.forEach((f) => setValue(f, null));
};
